import { hotList } from '@/mocks/gossip';

export default function HotList() {
  return (
    <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-fire-fill h-5 w-5 text-primary-500" />
          全网热瓜 TOP
        </h3>
        <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-semibold text-accent-900">
          <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-accent-500" />
          实时
        </span>
      </div>
      <ol className="mt-5 space-y-1">
        {hotList.map((h, idx) => (
          <li key={h.rank}>
            <a
              href="#gusu"
              className="group flex items-center gap-3 rounded-lg px-2 py-2.5 transition-colors hover:bg-secondary-50"
            >
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
                  idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                }`}
              >
                {h.rank}
              </span>
              <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-foreground-950">
                {h.title}
              </span>
              <span className="shrink-0 whitespace-nowrap text-xs text-foreground-400">{h.heat}</span>
            </a>
          </li>
        ))}
      </ol>
    </div>
  );
}